import {
  IResetPrimaryColors,
  IResetSecondaryColors,
  ISettingsSearchParams,
  ISettingsUpdate,
} from '../../resource/settings/settings.types';
import { IApiRequestConfig } from '../api.types';

export const searchSettingsApi = (params?: ISettingsSearchParams): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'searchSettings',
  action: 'general-settings',
  method: 'get',
  params: {
    ...params,
  },
  v2: true,
});

export const saveSettingsApi = (data: ISettingsUpdate): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'saveSettings',
  action: 'general-settings',
  method: 'post',
  data,
  v2: true,
});

export const resetSettingsColorsApi = (
  data: IResetPrimaryColors | IResetSecondaryColors,
): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'resetSettingsColors',
  action: 'general-settings',
  method: 'post',
  data,
  v2: true,
});
